import { create } from 'zustand';

const useRootOrganizationStore = create((set) => ({
    rootOrganization: null,
    storeRootOrganization: (rootOrganization) => set(() => ({ rootOrganization: rootOrganization }))
}));

export default useRootOrganizationStore;